// @flow
import type { AttributeDefinition } from '~/core/constants/actions';
import type { HiveLiveRequirement } from '../types';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import generalIcons from '~/core/constants/icons/general-svg';
import messages from '../../intl';
import { ItemExclamation, ItemIcon, ItemRequired, ItemTexts, ListItem } from './styles';

type Props = {
    definition: AttributeDefinition,
    hiveLive: HiveLiveRequirement,
    isRequired?: boolean,
    missingDevice: boolean
};
export default ({ definition, hiveLive, isRequired, missingDevice }: Props) => (
    <ListItem>
        <ItemIcon type={definition.icon} />
        <ItemTexts>
            <FormattedMessage {...definition.text} />
            {missingDevice &&
                isRequired && (
                    <ItemRequired>
                        <FormattedMessage {...messages.deviceRequired} />
                    </ItemRequired>
                )}
            {!missingDevice &&
                hiveLive !== 'notRequired' && (
                    <ItemRequired noError={hiveLive === 'requiredAndHave'}>
                        <FormattedMessage {...messages.hiveLiveRequired} />
                    </ItemRequired>
                )}
        </ItemTexts>
        {(missingDevice || hiveLive === 'requiredButDontHave') && <ItemExclamation type={generalIcons.EXCLAMATION} />}
    </ListItem>
);



// WEBPACK FOOTER //
// ./src/components/widgets/actions/template-description/description-item/component.js